<template>
  <q-form
    @submit="onSubmit"
    class="q-gutter-md"
  >
    <q-input
      dense
      outlined
      type="email"
      ref="email"
      no-error-icon
      v-model="credentials.email"
      placeholder="E-mail do Reuni"
      autocorrect="off"
      autocapitalize="off"
      autocomplete="off"
      spellcheck="false"
      hide-bottom-space
      :rules="[
        () => $v.credentials.email.required || 'E-mail é obrigatório',
        () => $v.credentials.email.email || 'E-mail inválido'
      ]"
    >
      <template #prepend>
        <q-icon
          name="mdi-account"
          size="xs"
        />
      </template>

      <template #append>
        <q-icon
          size="xs"
          name="mdi-close"
          class="cursor-pointer"
          v-show="credentials.email"
          @click="credentials.email = ''"
        />
      </template>
    </q-input>

    <div class="row items-center justify-between">
      <q-btn
        flat
        dense
        no-caps
        padding="0"
        :ripple="false"
        color="primary"
        label="Voltar"
        :to="authLoginRoute"
      />

      <AuthSubmit
        label="Recuperar"
        :loading="auth.loading"
      />
    </div>
  </q-form>
</template>

<script>
import { mapState } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'
import { ROUTE_AUTH_SIGN_IN, ACTION_AUTH_FORGOT_PASSWORD } from '../constants'
import AuthSubmit from '../components/AuthSubmit'

export default {
  components: {
    AuthSubmit
  },

  data () {
    return {
      credentials: {},
      authLoginRoute: { name: ROUTE_AUTH_SIGN_IN }
    }
  },

  mounted () {
    this.$nextTick().then(() => (
      this.$refs.email.focus()
    ))
  },

  computed: {
    ...mapState({
      auth: ({ authStore }) => authStore
    })
  },

  validations: {
    credentials: {
      email: { required, email }
    }
  },

  methods: {
    onSubmit () {
      if (this.auth.loading) return
      this.$store.dispatch(ACTION_AUTH_FORGOT_PASSWORD, this.credentials.email)
    }
  }
}
</script>
